export default __webpack_public_path__ + "static/media/placeholder.507ec7d6.svg";